import React, { useEffect, useState } from "react";
import Navbar from "../../../Shared/Navbar/Navbar";
import Sidebar from "../../../Shared/Sidebar";
import Preloader from "../../../Shared/Preloader/Preloader";
import LessSidebar from "../../../Shared/LessSidebar";
import { currentUser } from "../../../../authentication/auth";
import { useNavigate } from "react-router-dom";
import { faBriefcase } from "@fortawesome/free-solid-svg-icons";
import LaboratoryService from "../../../services/LaboratoireService";
import Kanban from "./Kanban";
import { Button, Spinner } from "@themesberg/react-bootstrap";
import Select from "react-select";
import Services from "./Filters/Services";
import Works from "./Filters/Works";
import Dentists from "./Filters/Dentists";
import Coursiers from "./Filters/Coursiers";
import { transformToTasks } from "../../../../helpers";
export default function () {
  const [works, setWorks] = useState([]);
  const [showServiceFilter, setShowServiceFilter] = useState(false);
  const [showDentistFilter, setShowDentistFilter] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const [user, setUser] = useState();

  const [filters, setFilters] = useState({
    tasks: [],
    entredTasks: [],
    dentists: [],
    travaux: 3, // 1 , 2 , 3
    entredWorks: 0,
    sortedWorks: 0,
    coursiers: [],
    works: [],
    allWorks: [],
    service: null,
    groupe: null,
  });

  const getWorks = async () => {
    setLoading(true);
    let tsks = filters.tasks;
    try {
      const response = await LaboratoryService.works();
      let ltasks = [...response.data.data].filter(
        (w) =>
          ["outgoing_dentist", "outgoing_laboratory"].includes(w.status) &&
          w.courier_id == null
      );

      setWorks(ltasks);

      let transformedTasks = transformToTasks(ltasks, tsks);
      let totalTasks = transformedTasks[1];
      let entredTasks = transformedTasks[0];
      let lcoursiers = [];
      const response1 = await LaboratoryService.couriersAll();
      if (response1.status === 200) {
        response1.data.data.map((d) => {
          lcoursiers.push(d);
        });
      }

      setFilters({
        ...filters,
        allWorks: response.data.data,
        works: ltasks,
        coursiers: lcoursiers,
        tasks: totalTasks,
        entredTasks: entredTasks,
        entredWorks: ltasks.filter((w) => w.status === "outgoing_dentist")
          .length,
        sortedWorks: ltasks.filter((w) => w.status === "outgoing_laboratory")
          .length,
      });
      setLoading(false);
    } catch (Err) {
      console.log(Err);
      setLoading(false);
    }
  };

  useEffect(() => {
    console.log("kanban render ");
    if (currentUser() == null) {
      navigate("/login");
    } else {
      setUser(currentUser());
      getWorks();
      //getCoursiers();
    }
  }, []);

  const updateWorksList = () => {
    let tsks = filters.tasks;
    let ltasks = works;
    if (filters.travaux == 1) {
      ltasks = [...works].filter(
        (w) => w.status === "outgoing_dentist" && w.courier_id == null
      );
    } else if (filters.travaux == 2) {
      ltasks = [...works].filter(
        (w) => w.status === "outgoing_laboratory" && w.courier_id == null
      );
    }
    if (filters.dentists.length > 0) {
      ltasks = [...ltasks].filter((w) =>
        filters.dentists.includes(w.dentist_id)
      );
    }
    if (filters.service && filters.service != 0) {
      ltasks = [...ltasks].filter((w) => w.service_id == filters.service);
    } else if (filters.groupe && filters.groupe != 0) {
      ltasks = [...ltasks].filter(
        (w) => w.service.sub_group_id == filters.groupe
      );
    }
    // ltasks = [];
    let transformedTasks = transformToTasks(ltasks, tsks);
    let totalTasks = transformedTasks[1];
    let entredTasks = transformedTasks[0];
    setFilters({
      ...filters,
      tasks: totalTasks,
      entredTasks: entredTasks,
    });
  };

  useEffect(() => {
    updateWorksList();
  }, [
    filters.service,
    filters.groupe,
    filters.dentists.length,
    filters.travaux,
    filters.update,
  ]);

  const [hideSidebar, setHideSidebar] = useState(
    JSON.parse(localStorage.getItem("sidebar-state"))
  );

  const updateStatusService = (status) => {
    setShowServiceFilter(status);
    if (!status) {
      setFilters({
        ...filters,
        service: 0,
        groupe: 0,
      });
    }
  };

  const updateDentistService = (status) => {
    setShowDentistFilter(status);
    if (!status) {
      setFilters({
        ...filters,
        dentists: [],
      });
    }
  };

  return (
    <>
      <Preloader />

      <div className={`content`}>
        {hideSidebar ? (
          <LessSidebar
            user={user}
            expand={() => {
              setHideSidebar(false);
              localStorage.setItem("sidebar-state", false);
            }}
          />
        ) : (
          <Sidebar
            user={user}
            expand={() => {
              setHideSidebar(true);
              localStorage.setItem("sidebar-state", true);
            }}
          />
        )}
      </div>
      {/* <FirebaseNotif /> */}
      <main className={`content ${hideSidebar ? "mleft-0" : ""}`}>
        <Navbar user={user} pageName={"by Courier"} icon={faBriefcase} />
        <hr />

        {loading ? (
          <Spinner animation="border" />
        ) : (
          <>
            <div className="d-flex  border border-1 p-2 flex-wrap">
              <div className="col-12"> Filtrer par : </div>
              <div className="d-flex gap-2 align-items-center col-12">
                <div className="col-4">
                  <Works
                    filters={filters}
                    setFilters={(values) => setFilters(values)}
                  />
                </div>
                <div className="col-3 d-flex flex-wrap justify-content-center gap-2">
                  <div>
                    <h4>Dentists</h4>
                    <Button
                      className="mt-2"
                      onClick={(e) => updateDentistService(!showDentistFilter)}
                    >
                      {!showDentistFilter ? "Choisir" : "Tous"}
                    </Button>
                  </div>
                  <div>
                    <h4>Services</h4>
                    <Button
                      className="mt-2"
                      onClick={() => {
                        updateStatusService(!showServiceFilter);
                      }}
                    >
                      {!showServiceFilter ? "Choisir" : "Tous"}
                    </Button>
                  </div>
                </div>
                <div className="col-5  pe-4">
                  <Coursiers
                    filters={filters}
                    setFilters={(values) => setFilters(values)}
                  />
                </div>
              </div>
              <div className="col-12">
                {showDentistFilter && (
                  <Dentists
                    filters={filters}
                    setFilters={(values) => setFilters(values)}
                  />
                )}
                {showServiceFilter && (
                  <Services
                    filters={filters}
                    setFilters={(values) => setFilters(values)}
                  />
                )}
              </div>
            </div>
            <hr />
            {loading ? (
              <Spinner animation="border" />
            ) : (
              <Kanban
                refreshWorks={() => getWorks()}
                setFilters={(values) => setFilters(values)}
                filters={filters}
              />
            )}
          </>
        )}
      </main>
    </>
  );
}
